import React from "react"

import styles from "./index.module.scss"
import Input from "../../components/Input/Input"
import PasswordInput from "../../components/PasswordInput/PasswordInput"
import Button from "../../components/Button/Button"
import ConfirmCancelPopup from "../../components/Popup/ConfirmCancelPopup"

const AccountSettingsFormContent = ({
  type,
  onCancel,
  closeForm,
  values,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  isSubmitting,
}) => {
  const [isPopupOpened, setIsPopupOpened] = React.useState(false)

  const handleCancel = () => {
    if (Object.keys(touched).length) {
      setIsPopupOpened(true)
    } else {
      closeForm()
    }
  }

  return (
    <div className={styles.formWrap}>
      {isPopupOpened && (
        <ConfirmCancelPopup
          setIsPopupOpened={setIsPopupOpened}
          handleCancel={() => {
            onCancel ? onCancel() : closeForm()
            setIsPopupOpened(false)
          }}
        />
      )}

      <form onSubmit={handleSubmit} autoComplete="off">
        <Input
          type="text"
          name="type"
          value={values.type}
          label=""
          autoComplete="off"
          onChange={handleChange}
          onBlur={handleBlur}
          hidden
        />

        {type === "email" && (
          <React.Fragment>
            <div className={styles.formItem}>
              <Input
                type="text"
                name="current_email"
                value={values.current_email || ""}
                placeholder="Enter current email address"
                label="Current email"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.current_email && touched.current_email}
                errorMessage={errors.current_email && touched.current_email && errors.current_email}
                disabled
              />
            </div>
            <div className={styles.formItem}>
              <Input
                type="text"
                name="email"
                value={values.email}
                placeholder="Enter new email address"
                label="New email"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.email && touched.email}
                errorMessage={errors.email && touched.email && errors.email}
              />
            </div>
            <div className={styles.formItem}>
              <Input
                type="text"
                name="confirm_email"
                value={values.confirm_email || ""}
                placeholder="Enter new email address again"
                label="Confirm your new email"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.confirm_email && touched.confirm_email}
                errorMessage={errors.confirm_email && touched.confirm_email && errors.confirm_email}
              />
            </div>
          </React.Fragment>
        )}

        {type === "phone_number" && (
          <div className={styles.formItem}>
            <Input
              type="text"
              name="phone_number"
              value={values.phone_number}
              placeholder="Type here"
              label="Enter new phone number"
              autoComplete="off"
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.phone_number && touched.phone_number}
              errorMessage={
                errors.phone_number &&
                touched.phone_number &&
                errors.phone_number
              }
            />
          </div>
        )}

        {type === "password" && (
          <React.Fragment>
            <div className={styles.passwordRequirements}>
              <p>
                To change your password, please fill in the fields below. Your password must contain at least 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.
              </p>
            </div>
            <div className={styles.formItem}>
              <PasswordInput
                name="old_password"
                value={values.old_password}
                placeholder="Enter current password"
                label="Current password"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.old_password && touched.old_password}
                errorMessage={
                  errors.old_password &&
                  touched.old_password &&
                  errors.old_password
                }
              />
            </div>
            <div className={styles.formItem}>
              <PasswordInput
                name="password"
                value={values.password}
                placeholder="Enter new password"
                label="New password"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.password && touched.password}
                errorMessage={
                  errors.password && touched.password && errors.password
                }
              />
            </div>
            <div className={styles.formItem}>
              <PasswordInput
                name="confirm_password"
                value={values.confirm_password}
                placeholder="Enter new password again"
                label="Confirm new password"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.confirm_password && touched.confirm_password}
                errorMessage={
                  errors.confirm_password &&
                  touched.confirm_password &&
                  errors.confirm_password
                }
              />
            </div>
          </React.Fragment>
        )}

        <div className={styles.formBottom}>
          <div className={styles.formBottomItem}>
            <Button
              type="button"
              onClick={handleCancel}
              buttonStyle="outlined"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>

          <div className={styles.formBottomItem}>
            <Button type="submit" disabled={isSubmitting}>
              {type === "email" ? "Update Email" : type === "password" ? "Change Password" : "Save"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AccountSettingsFormContent
